// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'share-case';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M1.031 10.594v6.375m10.625-1.063a2.125 2.125 0 0 0-2.125-2.125H6.875a2.125 2.125 0 0 0-2.125-2.125H1.031v4.25zM4.75 13.781h2.125m-1.24-4.25V4.573a1.417 1.417 0 0 1 1.417-1.417h8.5a1.417 1.417 0 0 1 1.417 1.417V9.53a1.417 1.417 0 0 1-1.417 1.417h-7.26M5.635 5.99H16.97m-5.668 0v1.416m2.125-4.25h-4.25l.256-1.533a.708.708 0 0 1 .7-.592h2.338a.708.708 0 0 1 .698.592z'
  />
);

export const viewBox = '0 0 18 18';
